'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadInviteAFriendError = exports.loadInviteAFriend = exports.LOAD_INVITE_A_FRIEND_ERROR = exports.LOAD_INVITE_A_FRIEND = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doLoadInviteAFriend = doLoadInviteAFriend;
exports.watchInviteAFriendSagas = watchInviteAFriendSagas;

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _helpers = require('redux/saga/helpers');

var _multitrack = require('helpers/multitrack');

var _bound = require('redux/saga/entities/bound');

var _localStorage = require('redux/saga/helpers/local-storage');

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadInviteAFriend),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchInviteAFriendSagas);

var LOAD_INVITE_A_FRIEND = exports.LOAD_INVITE_A_FRIEND = 'LOAD_INVITE_A_FRIEND';
var LOAD_INVITE_A_FRIEND_ERROR = exports.LOAD_INVITE_A_FRIEND_ERROR = 'LOAD_INVITE_A_FRIEND_ERROR';

var loadInviteAFriend = exports.loadInviteAFriend = function loadInviteAFriend(token) {
  return { type: LOAD_INVITE_A_FRIEND, token: token };
};
var loadInviteAFriendError = exports.loadInviteAFriendError = _helpers.errorActionCreator.bind(null, LOAD_INVITE_A_FRIEND_ERROR);

function doLoadInviteAFriend(client, _ref) {
  var token = _ref.token;

  var _ref2, _ref3, referral, hasSchedule, variantName, variantId;

  return _regenerator2.default.wrap(function doLoadInviteAFriend$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userActionCampaign, [client, token], { key: token }), (0, _effects.call)(_localStorage.writeLocalStorage, 'invite_a_friend--conversion', { token: token })]);

        case 3:
          _ref2 = _context.sent;
          _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
          referral = _ref3[0];
          hasSchedule = (0, _deep.deepExtract)('schedule', referral);

          if (!hasSchedule) {
            _context.next = 12;
            break;
          }

          variantName = (0, _deep.deepExtract)('variant.variationName', referral, 'Original');
          variantId = (0, _deep.deepExtract)('variant.variationId', referral);
          _context.next = 12;
          return (0, _effects.all)([(0, _effects.spawn)(_multitrack.ec, 'IaF - Landing Page Shown', {
            campaign_id: (0, _deep.deepExtract)('campaign.campaign_id', referral),
            referral_id: (0, _deep.deepExtract)('referral_id', referral),
            spots: (0, _deep.deepExtract)('schedule.availability.status', referral),
            venue_id: (0, _deep.deepExtract)('schedule.venue.id', referral),
            class_id: (0, _deep.deepExtract)('schedule.class.id', referral),
            schedule_id: (0, _deep.deepExtract)('schedule.id', referral),
            promo_code: token,
            variant_name: variantName,
            variant_id: variantId
          }), (0, _effects.spawn)(_multitrack.ga, 'IAF - Landing page', variantName, variantName + ' : ' + variantId)]);

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](0);
          _context.next = 18;
          return (0, _effects.put)(loadInviteAFriendError(_context.t0));

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 14]]);
}

function watchInviteAFriendSagas(client) {
  return _regenerator2.default.wrap(function watchInviteAFriendSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_INVITE_A_FRIEND, doLoadInviteAFriend, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}